import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Send } from 'lucide-react';

export default function Footer() {
  const [lang, setLang] = useState('En');

  useEffect(() => {
    const syncLang = () => {
      setLang((localStorage.getItem('januslang') || localStorage.getItem('janus_lang')) === 'Fr' ? 'Fr' : 'En');
    };
    syncLang();
    window.addEventListener('langchange', syncLang);
    window.addEventListener('januslangchanged', syncLang);
    return () => {
      window.removeEventListener('langchange', syncLang);
      window.removeEventListener('januslangchanged', syncLang);
    };
  }, []);

  const translations = {
    Fr: {
      expertisesTitle: "Expertises",
      wealth: "Gestion & Allocation d'actifs",
      realEstate: "Immobilier de Prestige",
      digital: "Actifs Numeriques",
      sovereignty: "Souverainete",
      corporateTitle: "Corporate",
      story: "Notre Histoire & ADN",
      insights: "Analyses Macro",
      connectTitle: "Connexion",
      resourcesTitle: "Ressources",
      legal: "Mentions Legales",
      privacy: "Politique de Confidentialite",
      risk: "Avertissement sur les Risques",
      rights: "Tous Droits Reserves. Protocole de Securite Prive."
    },
    En: {
      expertisesTitle: "Expertise",
      wealth: "Wealth & Asset Allocation",
      realEstate: "Luxury Real Estate",
      digital: "Digital Assets Integration",
      sovereignty: "Corporate Sovereignty",
      corporateTitle: "Corporate",
      story: "Our Story & DNA",
      insights: "Macro Insights",
      connectTitle: "Connect",
      resourcesTitle: "Resources",
      legal: "Legal Notice",
      privacy: "Privacy Policy",
      risk: "Risk Disclosure",
      rights: "All Rights Reserved. Private Trust Security Protocol."
    },
    Ar: {
      expertisesTitle: "الخبرات",
      wealth: "إدارة الأصول والثروات",
      realEstate: "العقارات الفاخرة",
      digital: "دمج الأصول الرقمية",
      sovereignty: "السيادة والتأسيس",
      corporateTitle: "الشركة",
      story: "قصتنا وهويتنا",
      insights: "التحليلات الكبرى",
      connectTitle: "تواصل",
      resourcesTitle: "الموارد",
      legal: "الإشعار القانوني",
      privacy: "سياسة الخصوصية",
      risk: "الإفشاء عن المخاطر",
      rights: "جميع الحقوق محفوظة. بروتوكول أمان خاص."
    }
  };

  const t = translations[lang] || translations.En;
  const isRtl = false;

  return (
    <footer className="bg-white text-gray-800 py-16 px-6 lg:px-12 border-t border-gray-100 font-sans" dir={isRtl ? 'rtl' : 'ltr'}>
      <div className="max-w-[1400px] mx-auto flex flex-col items-center">

        <div className="mb-12">
          <Link to="/"><img src="https://januscapitalstrategy.com/uploads/images/1784356715733-logo_janus.webp" alt="Janus Capital Arche" className="h-16 w-auto object-contain cursor-pointer" /></Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 text-left w-full max-w-5xl mb-12">

          <div>
            <h4 className="text-black text-xs font-bold uppercase tracking-widest mb-6">{t.expertisesTitle}</h4>
            <ul className="space-y-3 text-xs font-light text-gray-600">
              <li><Link to="/asset-management" className="hover:text-[var(--color-gold)] transition-colors">{t.wealth}</Link></li>
              <li><Link to="/portfolio" className="hover:text-[var(--color-gold)] transition-colors">{t.realEstate}</Link></li>
              <li><Link to="/digital-assets" className="hover:text-[var(--color-gold)] transition-colors">{t.digital}</Link></li>
              <li><Link to="/sovereignty" className="hover:text-[var(--color-gold)] transition-colors">{t.sovereignty}</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-black text-xs font-bold uppercase tracking-widest mb-6">{t.corporateTitle}</h4>
            <ul className="space-y-3 text-xs font-light text-gray-600">
              <li><Link to="/janus" className="hover:text-[var(--color-gold)] transition-colors">{t.story}</Link></li>
              <li><Link to="/insights" className="hover:text-[var(--color-gold)] transition-colors">{t.insights}</Link></li>
            </ul>
          </div>

          <div className="flex flex-col items-start">
            <h4 className="text-black text-xs font-bold uppercase tracking-widest mb-6">{t.connectTitle}</h4>
            <div className="flex justify-start items-center gap-10 text-gray-500 h-full">
                <a href="https://www.linkedin.com/in/dimitri-yem/" target="_blank" rel="noopener noreferrer" className="text-[10px] font-black uppercase tracking-widest text-gray-400 hover:text-black transition">LinkedIn</a>
                <a href="https://januscapitalstrategy.com/telegram/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-[#0088cc] transition"><Send size={20}/></a>
                <a href="https://x.com/Architect_Janus" target="_blank" rel="noopener noreferrer" aria-label="X" className="text-gray-400 hover:text-black transition"><svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg></a>
            </div>
          </div>

          <div>
            <h4 className="text-black text-xs font-bold uppercase tracking-widest mb-6">{t.resourcesTitle}</h4>
            <ul className="space-y-3 text-xs font-light text-gray-600">
              <li><Link to="/mentions-legales" className="hover:text-[var(--color-gold)] transition-colors">{t.legal}</Link></li>
              <li><Link to="/confidentialite" className="hover:text-[var(--color-gold)] transition-colors">{t.privacy}</Link></li>
              <li><Link to="/avertissement-risques" className="hover:text-[var(--color-gold)] transition-colors">{t.risk}</Link></li>
            </ul>
          </div>

        </div>

      </div>
      <div className="max-w-[1400px] mx-auto mt-8 pt-8 border-t border-gray-100 text-center text-[10px] font-light tracking-wider uppercase text-gray-400">
        © {new Date().getFullYear()} JANUS CAPITAL. {t.rights}
      </div>
    </footer>
  );
}
